import classNames from "classnames";
import "./Headings.scss";

export function PhoneMain({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const phoneMainClassName = classNames("phone-main", className);
  return <div className={phoneMainClassName}>{children}</div>;
}
